export const enum StandardLicense {
  SM = "SM",
  XL = "XL",
  HD = "HD",
  UHD = "UHD"
};

export const enum ExtendedLicense {
  NONE = "NONE",    // No Extended License
  MPFR = "MPFR",    // Merchandise Product for Resale
  EX6M = "EX6M",    // Extended License 6 Months
  EX1Y = "EX1Y",    // Extended License 1 Year
  EX2Y = "EX2Y",    // Extended License 2 Years
  EX3Y = "EX3Y",    // Extended License 3 Years
  EX3PLUS = "EX3PLUS",  // Extended License 3+ Years
  VIP = "VIP"       // VIP License
};